import React from 'react';

import { hasActionPreview } from '~/components/AiChat/SideBarDialog/Actions/Action/ReviewAndExecute/ActionPreview';
import { ActionPreviewButton } from '~/components/AiChat/SideBarDialog/Actions/Action/ReviewAndExecute/ActionPreviewButton';
import type { AiAction } from '~/components/AiChat/types';
import { actionTitle } from '~/components/ClaimPage/CliveApp/ConductorHub/utils';

interface SettledActionPreviewProps {
  action: AiAction;
  subtitle?: string;
}

/** A rejected action filed nothing to look back at, so only an executed one is previewed once settled. */
export const isPreviewableOnceSettled = (action: AiAction): boolean => action.is_executed && hasActionPreview(action);

/** Preview on a settled card, which has no gestures to carry it. Render it where `isPreviewableOnceSettled` holds. */
const SettledActionPreview: React.FC<SettledActionPreviewProps> = ({ action, subtitle }) => (
  <div className="flex justify-end">
    <ActionPreviewButton action={action} title={actionTitle(action)} subtitle={subtitle} isDone />
  </div>
);

export default SettledActionPreview;
